'use strict';

angular.module('webAgro1App').factory('PluviometrosIntegracaoService', function($http) {
  return {
    upload: function(params) {
      return $http({
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        url: SERVER + API_VERSION + 'pluviometros_integracao/',
        data: params
      });
    }
  };
});